import type { WordListData } from '@/teoCore/TeoApi';
import type { DictionaryHandler } from '@/teoCore/text/WordListHandler/DictionaryHandler';
import type { PillGroup } from '@/ui/elements/tpi-drawer/TPIDrawer.svelte';

export type DictionaryPillGroup = Omit<PillGroup, 'key'> & { key: string };

export function createDictionaryPillGroups(handler: DictionaryHandler): DictionaryPillGroup[] {
  const pillGroups: DictionaryPillGroup[] = [];
  for (const wordList of handler.lists) {
    pillGroups.push({
      id: wordList.id.toString(),
      key: wordList.name,
      label: wordList.title,
      score: undefined,
      used: true,
      pills: [createPill(handler, wordList)],
    });
  }

  return pillGroups;
}

function createPill(
  handler: DictionaryHandler,
  wordList: WordListData,
): PillGroup['pills'][number] {
  const score = handler.getFoundEntries(wordList).length;
  return {
    id: wordList.id.toString(),
    key: wordList.name,
    type: 'MarkerPillData',
    label: 'Einträge',
    value: score,
  };
}
